import baseService from '../utils/axios';

const TEST_PREFIX = '/test';

export const createTestCase = async (testCase) => {
  return await baseService.post(`${TEST_PREFIX}/create`, testCase);
};

export const runInitialTest = async (testCase) => {
  return await baseService.post(`${TEST_PREFIX}/initial_test`, testCase);
};

export const runInitialTicketTest = async (testCase) => {
  return await baseService.post(`${TEST_PREFIX}/initial_ticket_test`, testCase);
};

export const getUserTestCases = async () => {
  return await baseService.get(`${TEST_PREFIX}/test_cases`);
}
